export const async_homedepot_product = {
  input: "320326855",
  result: `{
  "success": true,
  "payload": {
    "product": {
      "link": "https://www.homedepot.com/p/Milwaukee-M18-FUEL-18V-Lithium-Ion-Brushless-Cordless-1-2-in-Hammer-Drill-Driver-Tool-Only-2904-20/320326855",
      "brand": "Milwaukee",
      "title": "Milwaukee M18 FUEL 18V Lithium-Ion Brushless Cordless 1/2 in. Hammer Drill/Driver (Tool-Only)",
      "upc": "045242637720",
      "item_id": "320326855",
      "parent_id": "313560694",
      "store_sku": "1007901514",
      "model_number": "2904-20",
      "feature_bullets": [
        "Most powerful compact cordless hammer drill in its class",
        "Compact 6.9 in. length for access into tight spaces and reduced fatigue",
        "Fastest drilling and driving applications under load"
      ],
      "main_image": {
        "link": "https://images.thdstatic.com/productImages/66a60fa5-5897-46a9-bfb4-60e508951421/svn/milwaukee-hammer-drills-2904-20-64_1000.jpg",
        "type": "primary"
      },
      "rating": 4.7,
      "ratings_total": 1698,
      "specifications": [
        { "group_name": "Details", "name": "Chuck Size (In.)", "value": "1/2 In." },
        { "group_name": "Details", "name": "Maximum Speed (RPM)", "value": "2100 RPM" },
        { "group_name": "Details", "name": "Motor Type", "value": "Brushless" },
        { "group_name": "Details", "name": "Torque (lb-in)", "value": "1400 In lbs" }
      ],
      "buybox_winner": { "price": 229, "currency_symbol": "$", "currency": "USD", "unit": "each" }
    }
  }
}`
};
